import { createRequest, RequestConfig } from 'app/common/api';

import { TTariffProfile } from '../core/tariff-profile';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_tariff_profile',
};

export const getTariffProfileRequest = (id: TTariffProfile['id']) =>
  createRequest({
    url: config.url,
    method: config.method,
    query: {
      id: String(id),
    },
  });
